import { render } from "./PurchaseOrders.vue?vue&type=template&id=174bc87e&scoped=true"
import script from "./PurchaseOrders.vue?vue&type=script&lang=js"
export * from "./PurchaseOrders.vue?vue&type=script&lang=js"

import "./PurchaseOrders.vue?vue&type=style&index=0&id=174bc87e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174bc87e"]])

export default __exports__